export type ErrorDefinition = {
	friendlyMessage: string;
	docLink?: string;
	originalString?: string;
	fallback?: boolean;
	hydrationFailed?: boolean;
};

const DOC_LINK =
	'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';

export const HYDRATION_ERROR_FRAGMENTS: Array<{
	matchers: Array<RegExp>;
	friendlyError: ErrorDefinition;
	hydrationFailed: boolean;
}> = [
	{
		matchers: [/^Warning: Text content did not match. Server/],
		friendlyError: {
			friendlyMessage:
				"The text content didn't match. Are you placing time or dynamic content directly in the markup?",
			docLink: DOC_LINK,
		},

		hydrationFailed: false,
	},
	{
		matchers: [/^Warning: Prop `[^`]+` did not match\. Server:/],
		friendlyError: {
			friendlyMessage:
				"The prop values didn't match between server and client. Check for dynamic values or environment-specific logic that might differ during server-side rendering.",
			docLink: DOC_LINK,
		},
		hydrationFailed: false,
	},
	{
		matchers: [/^Warning: Expected server HTML to contain a matching/],
		friendlyError: {
			friendlyMessage: 'The server HTML did not match the client HTML.',
			docLink: DOC_LINK,
		},
		hydrationFailed: false,
	},
	{
		matchers: [
			/^(Uncaught )?Error: There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./,
		],
		friendlyError: {
			friendlyMessage:
				'Because hydration ultimately failed outside of a Suspense boundary, the root will switch to client rendering.',
			docLink: DOC_LINK,
		},
		hydrationFailed: true,
	},
	{
		matchers: [/^Warning: validateDOMNesting\(/],
		friendlyError: {
			friendlyMessage: 'A markup error occurred; the HTML structure used is invalid.',
			docLink: DOC_LINK,
		},
		hydrationFailed: false,
	},
	{
		matchers: [
			/^Warning: Using UNSAFE_componentWillReceiveProps in strict mode is not recommended/,
		],
		friendlyError: {
			friendlyMessage:
				'Using UNSAFE_componentWillReceiveProps can indicate issues in your code, please remove it.',
			docLink: DOC_LINK,
		},
		hydrationFailed: false,
	},
];

export const matchHydrationError = (errorString: string): ErrorDefinition => {
	for (const { matchers, friendlyError, hydrationFailed } of HYDRATION_ERROR_FRAGMENTS) {
		if (matchers.some((matcher) => matcher.test(errorString))) {
			return { ...friendlyError, originalString: errorString, hydrationFailed };
		}
	}

	return {
		friendlyMessage: 'An additional error occurred, attached below.',
		docLink: '',
		fallback: true,
		originalString: errorString,
		hydrationFailed: false,
	};
};
